import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class RBC_RESIDENTIAL_LETTER_OF_DIRECTION_Mapper extends BaseFormMapper<RBC_RESIDENTIAL_LETTER_OF_DIRECTION> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: RBC_RESIDENTIAL_LETTER_OF_DIRECTION,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as RBC_RESIDENTIAL_LETTER_OF_DIRECTION);

		return _formData;
	}

	MapValues(): Partial<RBC_RESIDENTIAL_LETTER_OF_DIRECTION> {
		return {};
	}
}

const Mappings: RBC_RESIDENTIAL_LETTER_OF_DIRECTION = {
	acknowledged: 'lawyerOfBorrower',
	borrower1: 'borrowerName1',
	borrower2: 'borrowerName2',
	dayYear: 'year',
	dayOf: 'month',
	datedAt: 'date',
	amount: 'amount',
	checkbox1: 'checkbox1',
	checkbox2: 'checkbox2',
	securedAgainst: 'securedAganist',
	mortgageNumber: 'mortgageNumber',
	from: 'borrower',
};

export interface RBC_RESIDENTIAL_LETTER_OF_DIRECTION {
	from: string;
	mortgageNumber: string;
	securedAgainst: string;
	amount: string;
	checkbox1: string;
	checkbox2: string;
	datedAt: string;
	dayOf: string;
	dayYear: string;
	borrower1: string;
	borrower2: string;
	acknowledged: string;
}
